import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CmsData } from 'models';

interface CmsState {
  status: '';
  cms: CmsData;
  videos: CmsData;
}

const initialState: CmsState = {
  status: '',
  cms: {
    data: [],
    metadata: {},
    settings: {},
    sid: 0,
    social: {
      fb: {},
      twitter: {},
    },
    text: {},
    ts: 0,
    wid: '',
  },
  videos: {
    data: [],
    metadata: {},
    settings: {},
    sid: 0,
    social: {
      fb: {},
      twitter: {},
    },
    text: {},
    ts: 0,
    wid: '',
  },
};

export const widgetSlice = createSlice({
  name: 'widget',
  initialState: initialState,
  reducers: {
    setMainWidgetData: (state: CmsState, action: PayloadAction<CmsData>) => {
      const payload: CmsData = action.payload;
      state.cms = {
        ...state.cms,
        ...payload,
      };
    },
    setVideosWidgetData: (state: CmsState, action: PayloadAction<CmsData>) => {
      const payload: CmsData = action.payload;
      state.videos = {
        ...state.videos,
        ...payload,
      };
    },
  },
});

export const { setMainWidgetData, setVideosWidgetData } = widgetSlice.actions;
export default widgetSlice.reducer;
